import React from 'react';
import { MqttConsumer } from 'helpers/mqtt/MqttProvider';
import { connect } from 'react-redux';

import { requestsOperations } from './duck';
import { requestsActions } from './duck';
import { appActions } from 'App/duck';
import RequestsComponent from './RequestsComponent';
import { userOperations } from '_data/modules/Users';
import { scheduleCalendarOperations } from 'pages/ScheduleCalendar/duck';

const mapStateToProps = ({ setupReducer, locationReducer, appReducer, requestsDuckReducer, scheduleCalendarReducer }) => ({
  locationConfig:
    setupReducer.setup_actions.meta.current_location.configuration,
  location: 
    locationReducer.locations.length > 1 ? locationReducer.location_data : locationReducer.locations[0],
  locationId: locationReducer.location_code,
  departments: appReducer.departments.data,
  myDepartments: appReducer.departments.myDepartments,
  totalRTOs: requestsDuckReducer.requestTimeOffs.total,
  onlineUsers: appReducer.onlineUsers.users,
  plans: appReducer.plans.data,
  locationData: locationReducer.location_data,
  allUsers: scheduleCalendarReducer.allUsers.users,
});

const mapDispatchToProps = (dispatch) => ({

  getScheduleUsers: (locationId, pageNo, numPerPage) => 
    dispatch(scheduleCalendarOperations.fetchScheduleUsers(locationId, pageNo, numPerPage)),

  handleShiftUpdate: (shift) =>
    dispatch(requestsOperations.handleShiftUpdate(shift)),
  approvePendingShift: (shift, configId) =>
    dispatch(requestsOperations.approvePendingShift(shift, configId)),
  getCostCenterData: (locationId) =>
    dispatch(requestsOperations.getCostCenterData(locationId)),

  getRequestTimeOffDispatch: (locationId, pageNo, numPerPage, sinceDate ) =>
    dispatch(requestsOperations.getRequestTimeOffs(locationId, pageNo, numPerPage, sinceDate)),

  getLocationEmployees: (locationId) =>
    dispatch(requestsOperations.getLocationEmployees(locationId)),
  getLocationUsableSkills: (locationId) =>
    dispatch(requestsOperations.getLocationUsableSkills(locationId)),
  getPendingUsers: (locationId) =>
    dispatch(userOperations.fetchPendingUsers(locationId)),
  getLocationInnerDepartments: (locationId) =>
    dispatch(requestsOperations.getLocationInnerDepartments(locationId)),
  getLocationMyDepartments: (locationId) =>
    dispatch(requestsOperations.getLocationMyDepartments(locationId)),
  
  getLocationEmployeesNew: (locationId) => {
    const params = {
    location_id: locationId,
    page: 1,
  };
    dispatch(requestsOperations.fetchAllUsers(params));
  },

  resetTotalRTOs: () => {
    dispatch(requestsActions.resetTotalRTOs(true));
  }
  
});

const RequestsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  return (
    <MqttConsumer>
      {(client) => {
        const { locationConfig,
                handleShiftUpdate,
                approvePendingShift, 
                location,
                locationId,
                getCostCenterData, 
                getRequestTimeOffDispatch,
                getLocationEmployees,
                getLocationEmployeesNew,
                getLocationUsableSkills,
                getPendingUsers,
                getLocationInnerDepartments,
                departments,
                getLocationMyDepartments,
                myDepartments,
                totalRTOs,
                resetTotalRTOs,
                onlineUsers,
                plans,
                locationData,
                allUsers,
                getScheduleUsers,
                } = props;

        return (
          <RequestsComponent
            mqttClient={client}
            locationConfig={locationConfig}
            handleShiftUpdate={handleShiftUpdate}
            approvePendingShift={approvePendingShift}
            location={location}
            locationId={locationId}
            getCostCenterData={getCostCenterData}
            getRequestTimeOffDispatch={getRequestTimeOffDispatch}
            getLocationEmployees={getLocationEmployees}
            getLocationEmployeesNew={getLocationEmployeesNew}
            getLocationUsableSkills={getLocationUsableSkills}
            getPendingUsers={getPendingUsers}
            getLocationInnerDepartments={getLocationInnerDepartments}
            departments={departments}
            getLocationMyDepartments={getLocationMyDepartments}
            myDepartments={myDepartments}
            totalRTOs={totalRTOs}
            resetTotalRTOs={resetTotalRTOs}
            onlineUsers={onlineUsers}
            plans={plans}
            locationData={locationData}
            allUsers={allUsers}
            getScheduleUsers={getScheduleUsers}
          />
        );
      }}
    </MqttConsumer>
  );
});

export default RequestsContainer;

